<div class="indicator" [ngClass]="'indicator-strength-' + score"></div>
